<template>
  <div>
    <pre class="log-content" ref="logContent" :class="{'hidden': !log}">
      <span v-if="log">
        <span v-for="part in log.parts">{{ part }}</span>
      </span>
    </pre>
    <div v-if="!log">
      <div v-if="canRequestLog">
        <button class="btn btn-fill btn-success btn-lg">Request log from the server</button>
      </div>
      <div v-else>
        <p>No log entry found.</p>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  props: {
    process_id: String,
    server_id: String,
    type: Number,
    thread: {
      type: Number,
      default: 1
    },
    canRequestLog: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.$refs.logContent.addEventListener('scroll', this.logScrollHandler);
  },
  watch: {
    log: async function (data) {
      if (data && !data.parts.length) {
        await this.logbookGetPage({id: data.id, page: 0});
        // this.$refs.logContent.addEventListener('scroll', this.logScrollHandler);
      }
      this.nextPage = data.parts.length - 1;
    }
  },
  computed: {
    ...mapGetters(['logbookGetList']),
    log: function () {
      return this.logbookGetList.find(log => {
        return log.process_id === this.process_id &&
          log.server_id === this.server_id &&
          log.type === this.type &&
          log.thread === this.thread
      });
    },
    canLoadNextPage: function () {
      return !this.loading && this.log && this.log.partCount >= this.nextPage + 1;
    }
  },
  data: function () {
    return {
      init: false,
      loading: false,
      nextPage: 1,
    };
  },
  methods: {
    ...mapActions(['logbookGetPage']),
    // tabChange: async function (index) {
    //   if (index === 1 && this.webgrabLog && !this.webgrabInit) {
    //     await this.logbookGetPage({id: this.webgrabLog.id, page: this.webgrabNextPage});
    //     this.webgrabNextPage++;
    //     this.$refs.webgrabLog.addEventListener('scroll', this.webgrabLogScrollHandler);
    //   }
    //
    //   if (index === 2 && this.licenseLog && !this.licenseInit) {
    //     await this.logbookGetPage({id: this.licenseLog.id, page: this.licenseNextPage});
    //     this.licenseNextPage++;
    //     this.$refs.licenseLog.addEventListener('scroll', this.licenseLogScrollHandler);
    //   }
    // },
    logScrollHandler: async function (e) {
      let target = e.target;
      if (target.scrollHeight && target.scrollTop / target.scrollHeight > 0.8) {
        if (this.canLoadNextPage) {
          this.loading = true;
          await this.logbookGetPage({
            id: this.log.id,
            page: this.nextPage
          });
          this.nextPage++;
          this.loading = false;
        }
      }
    },
  }
}
</script>
<style>
.log-content {
  text-align: left;
  max-height: 70vh;
  overflow: auto;
}

.log-content.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Logbook/LogTabs/LogLoader.vue